<ng-container *ngIf="fontSet && fontIcon; else materialIcon">
  <sn-icon class="fs__empty-state-faIcon" [fontSet]="fontSet" [fontIcon]="fontIcon"></sn-icon>
</ng-container>
<ng-template #materialIcon>
  <sn-icon class="fs__empty-state-materialIcon">{{ icon }}</sn-icon>
</ng-template>

<div class="title">{{ title }}</div>
<div class="content"><ng-content></ng-content></div>
